<template>
  <div>
    <header id="mainHeader">
      <div class="container">
        <div class="wrap d-flex justify-content-between align-items-center">
          <div class="left">
            <button
              type="button"
              class="toggle actionToggleMenu mr-md-4"
              v-if="authenticated"
              @click="$emit('toggle-main-sidebar', $event)"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
            <div
              class="logo"
              :class="{
                'd-none': isChapterOrPostManipulation,
                'd-md-inline-block': isChapterOrPostManipulation
              }"
            >
              <router-link to="/">
                  <img :src="logoUrl" alt="Scriv" />
              </router-link>
            </div>
          </div>
          <div class="right">
            <div class="menu">
              <template v-if="!authenticated">
                <ul>
                  <li class="mr-2 mr-md-4 mr-lg-5">
                    <router-link
                      :to="{ name: 'feed.show', params: { type: 'trending' } }"
                    >
                      Explorar
                    </router-link>
                  </li>
                  <li
                    class="mr-2 mr-md-4 mr-lg-5"
                  >
                    <Button class="btn-primary" v-b-modal.auth-modal>
                      Entrar
                    </Button>
                  </li>
                  <li>
                    <button
                      type="button"
                      class="btn-search"
                      @click="$emit('toggle-search', $event)"
                    >
                      <BaseIcon>
                        <SearchIcon />
                      </BaseIcon>
                    </button>
                  </li>
                </ul>
              </template>
              <template v-else>
                <ul>
                  <template
                    v-if="isChapterOrPostManipulation"
                  >
                    <li class="mr-1 mr-md-2">
                      <router-link
                        :to="{ name: 'posts.show', params: { username: 'scriv', slug: 'como-publicar' } }"
                        target="_blank"
                      >
                        <i
                          class="fas fa-question-circle cursor-pointer text-color2 font-size-small"
                          v-b-tooltip.hover="{ customClass: 'font-size-xSmall' }"
                          title="Quer saber como publicar na Scriv? Clique aqui para ver nosso guia de postagem!"
                          >
                        </i>
                      </router-link>
                    </li>
                    <li class="mr-1 mr-md-2">
                      <Button
                        class="btn-primary btnPosts"
                        @click="publish"
                        :loading="publishing"
                      >
                        {{ publishButtonText }}
                      </Button>
                    </li>
                    <li>
                      <Button
                        class="btn btn-outline-color2 btnPosts"
                        @click="saveDraft"
                        :loading="savingDraft"
                        v-if="$route.name === 'posts.create' || $route.name === 'posts.edit' || $route.name === 'chapters.create' || $route.name === 'chapters.edit' || $route.name === 'groups.posts.create' || $route.name === 'groups.posts.edit'"
                      >
                        Salvar rascunho
                      </Button>
                    </li>
                  </template>
                  <li v-else>
                    <b-dropdown
                      toggle-class="btn btn-primary dropdown-toggle"
                      variant="none"
                      menu-class="font-size-xSmall p-3 text-center"
                      no-caret
                      text="Escrever"
                    >
                      <b-dropdown-item
                        link-class="p-0"
                        :to="{ name: 'books.create' }"
                      >
                        Criar um livro
                      </b-dropdown-item>
                      <b-dropdown-item
                        link-class="p-0"
                        :to="{ name: 'posts.create' }"
                      >
                        <hr class="h-1 background-color2" />
                        Escrever um texto
                      </b-dropdown-item>
                      <b-dropdown-item
                        link-class="p-0"
                        v-if="user"
                        v-b-modal.select-for-chapter-creation
                      >
                        <hr class="h-1 background-color2" />
                        Escrever um capítulo
                      </b-dropdown-item>
                      <b-dropdown-item
                        link-class="p-0"
                        v-if="user"
                        v-b-modal.select-for-group-post-creation
                      >
                        <hr class="h-1 background-color2" />
                        Publicar em uma comunidade
                      </b-dropdown-item>
                    </b-dropdown>
                  </li>
                  <li
                    class="ml-2 ml-md-3"
                    :class="{
                      'd-none': isChapterOrPostManipulation,
                      'd-md-inline-block': isChapterOrPostManipulation
                    }"
                  >
                    <b-dropdown
                      toggle-class="p-0 bordered-0 d-flex"
                      variant="none"
                      menu-class="p-0"
                      no-caret
                      :disabled="!user"
                    >
                      <template v-slot:button-content>
                        <span class="btn-author-image" :style="profileImage"></span>
                      </template>
                      <div class="font-size-xSmall p-3">
                        <b-dropdown-item
                          link-class="p-0"
                          :to="{ name: 'users.show', params: { username: (user) ? user.username : 'me' } }"
                        >
                          <span class="font-weight-bold text-color2 d-block">{{ user && user.name }}</span>
                          @{{ user && user.username }}
                        </b-dropdown-item>

                        <hr class="h-1 background-color2" />

                        <ul>
                          <b-dropdown-item
                            link-class="p-0"
                            :to="{ name: 'users.show', params: { username: (user) ? user.username : 'me' } }"
                          >
                            Meu Perfil
                          </b-dropdown-item>
                          <b-dropdown-item
                            link-class="p-0"
                            :to="{ name: 'orders.index' }"
                          >
                            Minhas Compras
                          </b-dropdown-item>
                          <!-- <b-dropdown-item
                            link-class="p-0"
                            :to="{ name: 'subscriptions.index' }"
                          >
                            Minhas Assinaturas
                          </b-dropdown-item> -->
                          <!-- <b-dropdown-item
                            link-class="p-0"
                            :to="{ name: 'wallets.index' }"
                          >
                            Minha Carteira
                          </b-dropdown-item> -->
                          <!-- <b-dropdown-item
                            link-class="p-0"
                            :to="{ name: 'advanced-analytics.general.show' }"
                            v-if="user && user.is_scriv_pro_enabled"
                          >
                            Estatísticas Avançadas
                          </b-dropdown-item> -->
                          <b-dropdown-item
                            link-class="p-0"
                            :to="{ name: 'settings.show' }"
                          >
                            Configurações
                          </b-dropdown-item>
                          <li>
                            <a href="javascript:void(0);" @click.prevent="logout">Sair</a>
                          </li>
                        </ul>

                      </div>
                    </b-dropdown>
                  </li>
                  <li
                    class="ml-2 ml-md-3"
                    :class="{
                      'd-none': isChapterOrPostManipulation,
                      'd-md-inline-block': isChapterOrPostManipulation
                    }"
                  >
                    <button
                      type="button"
                      class="btn-search"
                      @click="$emit('toggle-search', $event)"
                    >
                      <BaseIcon>
                        <SearchIcon />
                      </BaseIcon>
                    </button>
                  </li>
                  <li
                    class="post-options"
                    :class="{
                      'd-inline-block': isChapterOrPostManipulation,
                      'd-md-none': isChapterOrPostManipulation,
                      'd-none': !isChapterOrPostManipulation
                    }"
                  >
                    <Button
                      class="btn-clean"
                      @click="openPostSidebar"
                    >

                        <i style="color: #F45B5B;margin-left: 12px; font-size: 20px" class="fas fa-cogs"></i>

                    </Button>
                  </li>
                </ul>
              </template>
            </div>
          </div>
        </div>
        <hr class="background-color2 h-2" />
      </div>
    </header>

    <TheSearch
      @toggle-search="$emit('toggle-search', $event)"
      :search-visible="searchVisible"
    />

    <AuthModal />
    <SelectChapterCreationModal />
    <SelectGroupPostCreationModal v-if="user" />
  </div>
</template>

<script>

import AuthModal from '@/components/auth/AuthModal'
import AuthService from '@/modules/auth/services/auth-service'
import variables from '@/mixins/variables'
import { mapState, mapActions } from 'vuex'

import BaseIcon from '@/components/common/Icon/BaseIcon.vue'
import Button from '@/components/common/Button/Button.vue'
import SearchIcon from '@/components/common/Icon/SearchIcon.vue'
import SelectChapterCreationModal from '@/components/books/SelectChapterCreationModal.vue'
import SelectGroupPostCreationModal from '@/components/groups/SelectGroupPostCreationModal'
import TheSearch from '@/components/search/TheSearch.vue'

export default {
  name: 'TheHeader',
  props: ['searchVisible'],
  components: {
    AuthModal,
    BaseIcon,
    Button,
    SearchIcon,
    SelectChapterCreationModal,
    SelectGroupPostCreationModal,
    TheSearch
  },
  mixins: [variables],
  computed: {
    ...mapState('auth', {
      authenticated: state => state.authenticated
    }),
    ...mapState('users', {
      user: state => state.user
    }),
    ...mapState('posts', {
      publishing: state => state.publishing,
      savingDraft: state => state.savingDraft,
      isSidebarOpen: state => state.isSidebarOpen,
      postData: state => state.postData
    }),
    ...mapState({
      nightMode: state => state.nightMode
    }),
    profileImage () {
      return {
        backgroundImage: this.user ? `url('${this.user.avatar}')` : `url('${this.noAvatarUrl}')`
      }
    },
    logoUrl () {
      if (this.nightMode) {
        return this.isChapterOrPostManipulation || this.$route.name === 'posts.show' ? '/images/layout/logo-white.png' : '/images/layout/logo-white.gif'
      } else {
        return this.isChapterOrPostManipulation || this.$route.name === 'posts.show' ? '/images/layout/logo.png' : '/images/layout/logo.gif'
      }
    },
    publishButtonText () {
      const routeName = this.$route.name
      if ((routeName === 'posts.edit' || routeName === 'books.edit' || routeName === 'chapters.edit' || routeName === 'groups.posts.edit') && this.postData && this.postData.status === 'published') return 'Salvar'
      else if (this.postData && this.postData.publish_method === 'schedule') return 'Agendar'
      return 'Publicar'
    },
    isChapterOrPostManipulation () {
      const routeName = this.$route.name
      return (routeName === 'posts.edit' || routeName === 'posts.create' || routeName === 'chapters.create' || routeName === 'chapters.edit' || routeName === 'groups.posts.create' || routeName === 'groups.posts.edit')
    }
  },
  methods: {
    ...mapActions('posts', [
      'setPublishing',
      'setSavingDraft',
      'setIsPostSidebarOpen'
    ]),
    async logout () {
      try {
        await AuthService.logout()
        this.$router.push('/')
        location.reload()
      } catch (error) {
        // console.log(error)
      }
    },
    async publish () {
      this.setPublishing({ publishing: true })
    },
    async saveDraft () {
      this.setSavingDraft({ savingDraft: true })
    },
    openPostSidebar () {
      this.setIsPostSidebarOpen({ isSidebarOpen: !this.isSidebarOpen })
    }
  }
}
</script>

<style lang="scss" scoped>

header {
  min-height: 95px;
  .container {
    .wrap {
      padding-top: 1.5rem;
      padding-bottom: .5rem;

      @include desktop {
        padding-bottom: 1rem;
      }
    }
  }

  #notification {
    background: $color1;
    max-height: 123px;

    a {
      &:hover {
        color: #fff;
      }
    }
  }

  .left {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .logo {
    img {
      width: 100px;
    }
  }

  .toggle {
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
    border: none;
    background: transparent;
    padding: 10px;
    margin-top: 6px;

    &:hover {
      span {
        background: $color2;
      }
    }

    span {
      display: block;
      width: 20px;
      height: 2px;
      background: $color1;
      margin-bottom: 4px;
      transition: all 0.2s ease-out;

      &:last-child {
        margin-bottom: 0;
      }
    }

    @include desktop {
      display: none;
    }
  }

  .menu {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    & > ul {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-bottom: 0;

      a {
        color: $color1;

        &:hover {
          color: $color2;
        }
      }

      a.btn-primary {
        color: #fff;

        &:focus, &:hover {
          color: $color2;
        }
      }
    }

    .btn-author-image {
      -webkit-border-radius: 30px;
      -moz-border-radius: 30px;
      border-radius: 30px;
      width: 38px;
      height: 38px;
      border: 0;
      display: inline-block;
      background-size: cover;
      background-position: center;
    }

    ::v-deep .dropdown-menu {
      border: none;
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      border-radius: 8px;
      -webkit-box-shadow: 0 0 10px 0 rgba(0,0,0,0.2);
      box-shadow: 0 0 10px 0 rgba(0,0,0,0.2);
      margin-top: 6px;

      hr {
        display: block;
      }

      ul {
        li {
          margin-bottom: 4px;
        }
      }
    }

    .btn-search, .btn-question {
      border: none;
      background: transparent;
      padding: 0;
    }
  }

}

.btn-clean {
  border-radius: 0;
}

.btnPosts {

  @media(max-width: 374px) {
    padding: .375rem 0.8rem;
  }

  font-size: 14px;
  white-space: nowrap;
  @include tablet {
    font-size: 16px;
  }
}

.logged {
  header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    background: #fff;
    width: 100%;
    -webkit-box-shadow: 0 0 10px 0 rgba(0,0,0,0.1);
    box-shadow: 0 0 10px 0 rgba(0,0,0,0.1);
    min-height: 80px;

    .container {
      .wrap {
        padding-top: 1rem;
      }
    }

    .logo {
      img {
        width: 90px
      }
    }

    hr {
      display: none;
    }

    .toggle {
      @include desktop {
        display: inline-block;
      }
    }
  }
}

.post-options {
  margin-left: -6px;
}

</style>
